<!-- part1学习潜力 -->
<template>
	<div class="page_part3">
		<div class="page_shadow page_main">
            <div class="top_header">学习力测评报告</div>
			<h5 class="header page_header">
				<span>Part{{partIndex}} 学习效力</span>
			</h5>
			<div class="header_detail_box">
				<p class="header_detail">学习效力指的是如何有效地学习，主要由方法效力和风格效力组成。其中，方法效力指的是学习策略，风格效力指的是学习风格。</p>
			</div>
			<p class="part_big_title part3_big_title part_big_title_num">{{partIndex}}.1 学习策略</p>
            <div class="header_detail_box">
                <p class="header_detail">学习策略指的是为了提高学习效率而制定的有关学习的复杂方案。它包括认知策略、元认知策略和资源管理策略。</p>
            </div>
            <p class="part_small_title part_small_title_num">{{partIndex}}.1.1 学习策略评估结果</p>
            <p class="total_score">您学习策略的水平值为<span class="score">{{total.score | toFixed(2)}}</span>，在同龄人当中<span class="grade">{{getGrade(total.score)}}</span>。</p>
            <!-- <p class="total_norm">本测评水平值范围0-5，常模范围为<span>{{total.lnorm}}-{{total.rnorm}}</span>。</p> -->
            <div class="content_box">
                <div :class="['strategy_box', 'box'+index]" v-for="(item, index) in strategyNorms" :key="index">
                    <p class="title">{{item.name}}</p>
                    <p class="score">水平: <span>{{getGrade(item.score)}}</span></p>
                </div>

                <div :class="['circle', 'circle'+idx]" v-for="(item, idx) in strategyNorms">
                    <div class="s_circle" :style="{ width: item.score*10 + 'px',height: item.score*10 + 'px',marginTop: -item.score*5 + 'px', marginLeft: -item.score*6 + 'px'}"></div>
                </div>
            </div>
            <div class="mark_box">
                <p>
                    <span class="bg_1"></span>
                    认知策略
                </p>
                <p>
                    <span class="bg_2"></span>
                    元认知策略
                </p>
                <p>
                    <span class="bg_3"></span>
                    资源管理策略
                </p>
            </div>


			<p class="big_page_number"></p>
		</div>
		<div class="page_shadow page_main">
            <div class="top_header">学习力测评报告</div>
			<p class="part_small_title part_small_title_num">{{partIndex}}.1.2 学习策略分析</p>
                <ThePart3Main title="认知策略---" name="复述策略" :normObj="strategyNorm[5]" :comment="strategyComment[5]" type="1"></ThePart3Main>
                <ThePart3Main title="认知策略---" name="精细加工策略" :normObj="strategyNorm[2]" :comment="strategyComment[2]" type="1"></ThePart3Main>
			<p class="big_page_number"></p>
		</div>
        <div class="page_shadow page_main">
            <div class="top_header">学习力测评报告</div>
            <p class="part_small_title"></p>
                <ThePart3Main title="认知策略---" name="组织策略" :normObj="strategyNorm[9]" :comment="strategyComment[9]" type="1"></ThePart3Main>
                <ThePart3Main title="认知策略---" name="反馈策略" :normObj="strategyNorm[4]" :comment="strategyComment[4]" type="1"></ThePart3Main>
            <p class="big_page_number"></p>
        </div>
        <div class="page_shadow page_main">
            <div class="top_header">学习力测评报告</div>
            <p class="part_small_title"></p>
                <ThePart3Main title="元认知策略---" name="计划策略" :normObj="strategyNorm[0]" :comment="strategyComment[0]" type="2"></ThePart3Main>
                <ThePart3Main title="元认知策略---" name="监控策略" :normObj="strategyNorm[10]" :comment="strategyComment[10]" type="2"></ThePart3Main>
            <p class="big_page_number"></p>
        </div>
        <div class="page_shadow page_main">
            <div class="top_header">学习力测评报告</div>
            <p class="part_small_title"></p>
                <ThePart3Main title="元认知策略---" name="调节策略" :normObj="strategyNorm[6]" :comment="strategyComment[6]" type="2"></ThePart3Main>
                <ThePart3Main title="资源管理策略---" name="时间管理策略" :normObj="strategyNorm[7]" :comment="strategyComment[7]" type="3"></ThePart3Main>
            <p class="big_page_number"></p>
        </div>
        <div class="page_shadow page_main">
            <div class="top_header">学习力测评报告</div>
            <p class="part_small_title"></p>
                <ThePart3Main title="资源管理策略---" name="环境管理策略" :normObj="strategyNorm[1]" :comment="strategyComment[1]" type="3"></ThePart3Main>
                <ThePart3Main title="资源管理策略---" name="心境管理策略" :normObj="strategyNorm[3]" :comment="strategyComment[3]" type="3"></ThePart3Main>
            <p class="big_page_number"></p>
        </div>
        <div class="page_shadow page_main">
            <div class="top_header">学习力测评报告</div>
            <p class="part_small_title"></p>
                <ThePart3Main title="资源管理策略---" name="求助策略" :normObj="strategyNorm[8]" :comment="strategyComment[8]" type="3"></ThePart3Main>
            <p class="big_page_number"></p>
        </div>
        <div class="page_shadow page_main">
            <div class="top_header">学习力测评报告</div>
            <p class="part_big_title part3_big_title part_big_title_num">{{partIndex}}.2 学习风格</p>
            <div class="header_detail_box">
                <!-- <p class="header_detail">学习风格指的是在学习时所习惯的方式，主要由对待信息的主动性程度、信息加工方式和信息加工速度三部分构成。学习风格具有个人特色，没有高低之分，不同风格各有优势。</p> -->
                <p class="header_detail">学习风格指的是在学习时所习惯的方式，主要由执行风格 、依存风格和决策风格三部分构成。学习风格具有个人特色，没有高低之分，不同风格各有优势。</p>
            </div>
            <p class="part_small_title par3_small_title part_small_title_num">{{partIndex}}.2.1 学习风格评估结果</p>
            <div class="header_detail_box">
                <p class="header_detail">在下表中学习风格水平值是你在各项学习风格指标中水平大小，常模范围是群体中大多数人在该项上的得分分布，你的水平大小分布在哪边表明你的学习风格偏向于哪个方向。</p>
            </div>
            <div class="table_box">
                <table>
                    <thead>
                        <tr>
                            <th>学习风格</th>
                            <th>学习风格水平值</th>
                            <th>常模范围</th>
                            <th width="340">学习风格偏向</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>执行风格</td>
                            <td>{{styleNorm1.score | toFixed(2)}}</td>
                            <td>{{styleNorm1.lnorm}}~{{styleNorm1.rnorm}}</td>
                            <td>
                                <div class="score_text">
                                    <p>执行型</p>
                                    <p>执行·创造型</p>
                                    <p>创造型</p>
                                </div>
                                <div class="score_line_box score_line_box1">
                                    <div class="score_line">
                                        <div class="line" :style="{left: styleNorm1.lnorm/200*294 + 'px', width: (styleNorm1.rnorm-styleNorm1.lnorm)/200*294 + 'px' }" :title="styleNorm1.lnorm + '~' +styleNorm1.rnorm">
                                            <div class="block" v-for="item in 20"></div>
                                        </div>
                                        <div class="score" :style="{left: styleNorm1.score/200*294-5 + 'px'}" :title="styleNorm1.score | toFixed(2)"></div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>依存风格</td>
                            <td>{{styleNorm2.score | toFixed(2)}}</td>
                            <td>{{styleNorm2.lnorm}}~{{styleNorm2.rnorm}}</td>
                            <td>
                                <div class="score_text">
                                    <p>依存型</p>
                                    <p>依存·独立型</p>
                                    <p>独立型</p>
                                </div>
                                <div class="score_line_box score_line_box2">
                                    <div class="score_line">
                                        <div class="line" :style="{left: styleNorm2.lnorm/200*294 + 'px', width: (styleNorm2.rnorm-styleNorm2.lnorm)/200*294 + 'px' }" :title="styleNorm2.lnorm + '~' +styleNorm2.rnorm">
                                            <div class="block" v-for="item in 20"></div>
                                        </div>
                                        <div class="score" :style="{left: styleNorm2.score/200*294-5 + 'px'}" :title="styleNorm2.score | toFixed(2)"></div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                      <tr>
                        <td>决策风格</td>
                        <td>{{styleNorm3.score | toFixed(2)}}</td>
                        <td>{{styleNorm3.lnorm }}~{{styleNorm3.rnorm}}</td>
                        <td>
                            <div class="score_text">
                                <p>冲动型</p>
                                <p>冲动·沉思型</p>
                                <p>沉思型</p>
                            </div>
                            <div class="score_line_box score_line_box3">
                                <div class="score_line">
                                    <div class="line" :style="{left: styleNorm3.lnorm/200*294 + 'px', width: (styleNorm3.rnorm-styleNorm3.lnorm)/200*294 + 'px' }" :title="styleNorm3.lnorm + '~' +styleNorm3.rnorm">
                                        <div class="block" v-for="item in 20"></div>
                                    </div>
                                    <div class="score" :style="{left: styleNorm3.score/200*294-5 + 'px'}" :title="styleNorm3.score | toFixed(2)"></div>
                                </div>
                            </div>
                        </td>
                      </tr>
                    </tbody>
                </table>
            </div>

            <p class="part_small_title part_small_title_num">{{partIndex}}.2.2 学习风格分析</p>
            <div class="main_box">
                <P class="main_title"><span class="block"></span>你的执行风格属于：{{comment1.name}}</P>
                <div class="main_score_box">
                    <div class="score_text">
                        <p>执行型</p>
                        <p>执行-创造型</p>
                        <p>创造型</p>
                    </div>
                    <div class="score_line_box score_line_box1">
                        <div class="score_line">
                            <div class="line" :style="{left: styleNorm1.lnorm/200*294 + 'px', width: (styleNorm1.rnorm-styleNorm1.lnorm)/200*294 + 'px' }" :title="styleNorm1.lnorm + '~' +styleNorm1.rnorm">
                                <div class="block" v-for="item in 20"></div>
                            </div>
                            <div class="score" :style="{left: styleNorm1.score/200*294-5 + 'px'}" :title="styleNorm1.score | toFixed(2)"></div>
                        </div>
                    </div>
                </div>
                <div class="advantage_box">
                    <div class="advantage">
                        <img src="~@/assets/report_imgs/icon_advantage.png" alt="">
                        <p>你的优势有：<span v-for="(item, index) in comment1.advantage">{{item.detail}}</span></p>
                    </div>
                    <div class="advantage">
                        <img src="~@/assets/report_imgs/icon_disadvantage.png" alt="">
                        <p>你的盲点有：<span v-for="(item, index) in comment1.disadvantage">{{item.detail}}</span></p>
                    </div>
                </div>

            </div>
            <p class="big_page_number"></p>
        </div>
        <div class="page_shadow page_main">
            <div class="top_header">学习力测评报告</div>
            <p class="part_small_title"></p>
            <div class="main_box">
                <P class="main_title"><span class="block"></span>你的依存风格属于：{{comment2.name}}</P>
                <div class="main_score_box">
                    <div class="score_text">
                        <p>依存型</p>
                        <p>依存-独立型</p>
                        <p>独立型</p>
                    </div>
                    <div class="score_line_box score_line_box2">
                        <div class="score_line">
                            <div class="line" :style="{left: styleNorm2.lnorm/200*294 + 'px', width: (styleNorm2.rnorm-styleNorm2.lnorm)/200*294 + 'px' }" :title="styleNorm2.lnorm + '~' +styleNorm2.rnorm">
                                <div class="block" v-for="item in 20"></div>
                            </div>
                            <div class="score" :style="{left: styleNorm2.score/200*294-5 + 'px'}" :title="styleNorm2.score | toFixed(2)"></div>
                        </div>
                    </div>
                </div>
                <div class="advantage_box">
                    <div class="advantage">
                        <img src="~@/assets/report_imgs/icon_advantage.png" alt="">
                        <p>你的优势有：<span v-for="(item, index) in comment2.advantage">{{item.detail}}</span></p>
                    </div>
                    <div class="advantage">
                        <img src="~@/assets/report_imgs/icon_disadvantage.png" alt="">
                        <p>你的盲点有：<span v-for="(item, index) in comment2.disadvantage">{{item.detail}}</span></p>
                    </div>
                </div>
            </div>
            <div class="main_box">
                <P class="main_title"><span class="block"></span>你的决策风格属于：{{comment3.name}}</P>
                <div class="main_score_box">
                    <div class="score_text">
                        <p>冲动型</p>
                        <p>冲动-沉思型</p>
                        <p>沉思型</p>
                    </div>
                    <div class="score_line_box score_line_box3">
                        <div class="score_line">
                            <div class="line" :style="{left: styleNorm3.lnorm/200*294 + 'px', width: (styleNorm3.rnorm-styleNorm3.lnorm)/200*294 + 'px' }" :title="styleNorm3.lnorm + '~' +styleNorm3.rnorm">
                                <div class="block" v-for="item in 20"></div>
                            </div>
                            <div class="score" :style="{left: styleNorm3.score/200*294-5 + 'px'}" :title="styleNorm3.score | toFixed(2)"></div>
                        </div>
                    </div>
                </div>
                <div class="advantage_box">
                    <div class="advantage">
                        <img src="~@/assets/report_imgs/icon_advantage.png" alt="">
                        <p>你的优势有：<span v-for="(item, index) in comment3.advantage">{{item.detail}}</span></p>
                    </div>
                    <div class="advantage">
                        <img src="~@/assets/report_imgs/icon_disadvantage.png" alt="">
                        <p>你的盲点有：<span v-for="(item, index) in comment3.disadvantage">{{item.detail}}</span></p>
                    </div>
                </div>
            </div>
            <p class="big_page_number"></p>
        </div>
	</div>
</template>
<script>
import ThePart3Main from './ThePart3Main.vue';//目录
export default {
	name: 'page_part3',
	components: { ThePart3Main },
    props: {
        strategyNorm: {
          type: Array//
          // required: true
        },
        strategyComment: {
            type: Array
            // required: true
        },
        styleNorm: {
          type: Object//
          // required: true
        },
        styleComment: {
            type: Object
            // required: true
        },
        partIndex: {
            type: Number
        }
    },
    data() {
        return {
        	// comment: null,
        	// norm: []
        }
    },
    computed: {
        total() {
            return this.strategyNorm[11];
        },
        strategyNorms() {
            return this.strategyNorm.slice(0,11);
        },
        styleNorm1() {
            return this.styleNorm.chuangxin;
        },
        styleNorm2() {
            return this.styleNorm.duli;
        },
        styleNorm3() {
            return this.styleNorm.chensi;
        },
        comment1() {
            return this.styleComment.chuangxin;
        },
        comment2() {
            return this.styleComment.duli;
        },
        comment3() {
            return this.styleComment.chensi;
        }
    },
    watch: {
    },
    created() {	
    },
    mounted() {
    },
    methods: {
        getGrade(value) {
            if(value <= 1) {
                return '低';
            }else if(value <= 2) {
                return '较低';
            }else if(value <= 3) {
                return '中等';
            }else if(value <= 4) {
                return '较高';
            }else {
                return '高';
            }
        },
        // getScore(score) {
        //     switch(score) {
        //         case 1:
        //             return '较低';
        //             break;
        //         case 2:
        //             return '较低';
        //             break;
        //         case 3:
        //             return '中等';
        //             break;
        //         case 4:
        //             return '较高';
        //             break;      
        //         case 5:
        //             return '高';
        //             break;          
        //     }
        // },
    }
}
</script>
<style type="text/css" lang='less' scoped>
	@import './report.less';
	.page_part3 {
        .content_box {
            position: relative;
            width: 100%;
            height: 680px;
            background: url(~@/assets/report_imgs/icon_xuexicelue.png) no-repeat center center;
            .strategy_box {
                line-height: 26px;
                font-size: 14px;
                position: absolute;
                .title {
                    font-weight: bold;
                }
            }
            .box5,.box2,.box9 ,.box4 {
                .title {
                    color: #DF6800;
                }
                .score {
                    span {
                        color: #FF9F7B;
                    }
                }
            }
            .box0,.box10,.box6 {
                .title {
                    color: #E77178;
                }
                .score {
                    span {
                        color: #FA8AA5;
                    }
                }
            }
            .box7,.box1,.box3 ,.box8 {
                .title {
                    color: #13ABA4;
                }
                .score {
                    span {
                        color: #41CBAA;
                    }
                }
            }
            .box5 {
                left: 220px;
                top: 20px;
            }
            .box2 {
                left: 10px;
                top: 90px;
            }
            .box9 {
                left: 10px;
                top: 240px;
            }
            .box4 {
                left: 50px;
                top: 310px;
            }

            .box0 {
                left: 90px;
                top: 445px; 
            }

            .box10 {
                left: 350px;
                bottom: 20px; 
            }

            .box6 {
                left: 440px;
                bottom: 130px; 
            }


            .box7 {
                right: 40px;
                bottom: 200px; 
            }

            .box1 {
                right: -20px;
                bottom: 300px; 
            }

            .box3 {
                right: 10px;
                bottom: 400px; 
            }

            .box8 {
                right: 20px;
                top: 110px; 
            }


            .circle {
                width: 5px;
                height: 5px;
                border-radius: 50%;
                position: absolute;
            }
            .s_circle {
                position: absolute;
                left: 50%;
                right: 50%;
                background-color: red;
                border-radius: 50%;
            }
            .circle5,.circle2,.circle9 ,.circle4 {
                .s_circle {
                    background-color: #FF9F7B;
                }
            }
            .circle0,.circle10,.circle6 {
                .s_circle {
                    background-color: #E77178;
                }
                
            }
            .circle7,.circle1,.circle3 ,.circle8 {
                .s_circle {
                    background-color: #41CBAA;
                }
            }

            .circle5 {
                left: 276px;
                top: 110px;
            }
            .circle2 {
                left: 130px;
                top: 140px;
            }
            .circle9 {
                left: 127px;
                top: 272px;
            }
            .circle4 {
                left: 165px;
                top: 332px;
            }


            .circle0 {
                left: 144px;
                top: 421px; 
            }

            .circle10 {
                left: 398px;
                bottom: 98px; 
            }

            .circle6 {
                left: 419px;
                bottom: 209px; 
            }


            .circle7 {
                right: 169px;
                bottom: 251px; 
            }

            .circle1 {
                right: 107px;
                bottom: 336px; 
            }

            .circle3 {
                right: 161px;
                bottom: 417px; 
            }

            .circle8 {
                right: 122px;
                top: 146px; 
            }

            
        }
        .total_score {
            color: #8a8a8a;
            span {
                font-weight: bold;
            }
            .score {
                color: #DE6400;
            }
            .grade {
                color: #E66971;
            }
        }
        .mark_box {
            width: 410px;
            height: 20px;
            margin: 0 auto;
            display: flex;
            justify-content: space-between;
            p {
                font-size: 14px;
                line-height: 20px;
                display: flex;
                align-items: center;
                .bg_1 {
                    background-color: #FF9F7B;
                }
                .bg_2 {
                    background-color: #E77178;
                }
                .bg_3 {
                    background-color: #41CBAA;
                }
                span {
                    width: 24px;
                    height: 13px;
                    border-radius: 2px;
                    margin-right: 7px;
                }
            }
        }
        .score_text {
            padding: 0 15px;
            line-height: 50px;
            display: flex;
            justify-content: space-between;
        }
        .score_line_box {
            width: 340px;
            height: 34px;
            .score_line {
                width: 294px;
                height: 18px;
                margin: 0 auto;
                border-radius: 9px;
                position: relative;
                .line {
                    height: 24px;
                    position: absolute;
                    top: -3px;
                    overflow: hidden;
                    .block {
                        float: left;
                        height: 24px;
                        width: 10px;
                        margin-right: 1px;
                    }
                }
                .score {
                    position: absolute;
                    top: -3px;
                    height: 24px;
                    width: 10px; 
                }
            }
        }
        .score_line_box1 {
            .score_line {
                background-color: #41CBAA;  
                .block {
                    background-color: rgba(14, 238, 184, 0.4);
                }
                .score {
                    background-color: #FDB523;
                }
            }
        }
        .score_line_box2 {
            .score_line {
                background-color: #FDB523;  
                .block {
                    background-color: rgba(255, 208, 20, 0.6);
                }
                .score {
                    background-color: #FA5F51;
                }
            }
        }
        .score_line_box3 {
            .score_line {
                background-color: #FE8E84;  
                .block {
                    background-color: rgba(252, 103, 84, 0.4);
                }
                .score {
                    background-color: #77D6FD;
                }
            }
        }
        .table_box {
            padding-bottom: 60px;
            tr {
                .c_line {
                    background-color: #41CBAA;
                }
                .c_linec {
                    background-color: #F08C00;
                }
                .c_line {
                    background-color: #E7A53C;
                }


                th {
                    background-color: #41CBAA;
                    color: #fff;
                    font-size: 16px;
                    line-height: 42px;
                    background-color: #41CBAA;
                    border: 1px solid #fff;
                    text-align: center;
                }
                td {
                    font-size: 14px;
                    height: 84px;
                    text-align: center;
                    background-color: #F7F7F7;
                    border: 1px solid #fff;


                }
            }
        }
        .main_score_box {
            width: 340px;
            margin-top: -20px;
        }
        .advantage_box {
            padding-top: 40px;
            .advantage {
                display: flex;
                height: 56px;
                align-items: center;
                line-height: 28px;
                margin-bottom: 35px;
                p {
                    font-weight: bold;
                    span {
                        font-weight: normal;
                        color: #8a8a8a;
                    }
                }
                img {
                    margin-right: 15px;
                }
            }
        }
        
	}
</style>
